import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ProjectsSection = () => {
  const projects = [
    {
      id: 1,
      title: "Task Management",
      description: 'This Task Management System features user registration and login, followed by a dynamic dashboard with columns for "To Do", "In Progress", "Completed", and "Frozen" tasks. New tasks are created in the "To Do" column by default, where users provide a title and short description. Using OpenAI LLM, the system auto-generates a detailed task description and assigns a priority level (Low, Medium, or High) based on the content. Tasks can be easily moved between columns by selecting the desired status. Users can also edit task details such as the due date and participants, or delete tasks as needed. The backend is built with FastAPI, and the frontend uses React.js for a seamless and responsive experience.',
      image: "https://res.cloudinary.com/dplsckp4p/image/upload/v1765183707/Screenshot_2025-12-08_at_2.17.10_PM_viafo2.png",
      technologies: ["Nodejs", "Mongodb", "Reactjs", "TailwindCSS", "Vercel", "Railway"],
      category: "Full-Stack",
      githubUrl: "https://github.com/tharsh95/ciphrix-task-manager-server",
      githubFeUrl: "https://github.com/tharsh95/ciphrix-task-manager-client",
      liveUrl: "https://ciphrix-task-manager-client.vercel.app/#//",
      features: [
        "AI-Powered Task Enhancement",
        "Dynamic Task Dashboard",
        "Flexible Task Management",
        "User Authentication & Personalizationn"
      ],
      status: "Live",
      duration: "1 month",
      color: "background"
    },
    {
      id: 2,
      title: "Receipt Scanner Web App",
      description: "The Receipt Scanner Web App is a full-stack application that allows users to upload receipts, automatically extract important information using OCR, and manage their expenses through a clean and intuitive interface. Built with React on the frontend and a Node.js/Express backend powered by OCR and PostgreSQL, the app streamlines expense tracking and provides actionable insights into spending patterns.",
      technologies: ["React.js", "Express.js", "MySQL", "OpenAILLM", "Typescript", "TailwindCSS", "Railway", "Vercel","TesseractOCR"],
      category: "Web App",
      image: "https://res.cloudinary.com/dplsckp4p/image/upload/v1765026411/Screenshot_2025-12-06_at_4.17.46_PM_nm3qku.png",
      githubUrl: "https://github.com/tharsh95/reciept-scan-backend",
      githubFeUrl: "https://github.com/tharsh95/receipt-scan-frontend",
      liveUrl: "https://receipt-scan-frontend.vercel.app/#",
      features: [
        "AI-powered OCR Receipt Scanning",
        "Secure User Authentication",
        "Interactive Expense Analytics"
      ],
      status: "Live",
      duration: "2 weeks",
      color: "background"
    },
    {
      id: 3,
      title: "Car Analytics Dashboard",
      description: "This project is a analytics dashboard designed to visualize and interpret vehicle inventory data, the dashboard transforms raw inventory data into clear, actionable insights for dealerships and automotive teams. It supports in-depth filtering, categorization, and historical tracking to help users understand trends across NEW, USED, and CPO (Certified Pre-Owned) vehicles.",
      image: "https://res.cloudinary.com/dplsckp4p/image/upload/v1765182791/Screenshot_2025-12-08_at_2.02.42_PM_ydbcz8.png",
      technologies: ["React.js", "TypeScript", "Chart.js", "Nodejs", "Mongodb", "TailwindCSS", "Vercel", "Railway"],
      category: "Analytics",
      githubUrl: "https://github.com/tharsh95/keisang-client",
      githubFeUrl: "https://github.com/tharsh95/keisang-server",
      liveUrl: "https://keisang-client.vercel.app/",
      features: [
        "Interactive data visualizations",
        "Multi-source data aggregation",
        "Historical trend analysis",
      ],
      status: "Live",
      duration: "2 days",
      color: "black"
    },
    {
      id: 4,
      title: "Leaning Management System",
      description: "This project is a full-stack learning content management platform that enables users to create, organize, and share structured educational content. It provides a modern interface for managing classes, courses, assignments, and personal portfolio artifacts, supported by a powerful backend with authentication, file uploads, AI-assisted content generation, and PDF processing.",
      image: "https://res.cloudinary.com/dplsckp4p/image/upload/v1765180422/Screenshot_2025-12-08_at_1.20.41_PM_ikjntq.png",
      technologies: ["Reactjs", "MongoDB", "JWT", "Nodejs", "Typsescript", "TailwindCSS", "Vercel", "Railway", "OpenAI", "Cloudinary"],
      category: "Full-Stack",
      githubUrl: "https://github.com/tharsh95/lms-be",
      githubFeUrl: "https://github.com/tharsh95/lms-fe",
      liveUrl: "https://lms-fe-rose.vercel.app/",
      features: [
        "Structured Content Management",
        "Secure Authentication",
        "File Uploads, Cloud Integration & PDF Processing",
        "AI-Powered Content Assistance"
      ],
      status: "Live",
      duration: "1 month",
      color: "black",
    }
  ];

  const categories = ["All", "Full-Stack", "Web App", "Analytics"];
  const [activeCategory, setActiveCategory] = React.useState("All");

  const filteredProjects = activeCategory === "All"
    ? projects
    : projects?.filter(project => project?.category === activeCategory);

  return (
    <section id="projects" className="py-20 bg-muted/30">
      <div className="w-full max-w-6xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center space-y-4 mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground">
            Featured Projects
          </h2>
          <div className="w-20 h-1 bg-primary rounded-full mx-auto"></div>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            A showcase of my recent work demonstrating expertise in full-stack development
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {categories?.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${activeCategory === category
                  ? 'bg-primary text-white shadow-elevation-1'
                  : 'bg-background text-muted-foreground hover:bg-muted hover:text-foreground'
                }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {filteredProjects?.map((project, index) => (
            <div
              key={project?.id}
              className="bg-background rounded-xl overflow-hidden shadow-elevation-1 hover:shadow-elevation-3 transition-all duration-300 group animate-fade-in-stagger"
              style={{ '--stagger-delay': `${index * 150}ms` }}
            >
              {/* Project Image */}
              <div className="relative h-48 overflow-hidden">
                <Image
                  src={project?.image}
                  alt={project?.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 left-4 flex gap-2">
                  <span className="bg-primary text-white px-3 py-1 rounded-full text-xs font-medium">
                    {project?.category}
                  </span>
                  <span className="bg-success text-white px-3 py-1 rounded-full text-xs font-medium">
                    {project?.status}
                  </span>
                </div>
                <div className="absolute top-4 right-4">
                  <span className={`bg-background/90 text-${project?.color} px-3 py-1 rounded-full text-xs font-medium`}>
                    {project?.duration}
                  </span>
                </div>
              </div>

              {/* Project Content */}
              <div className="p-6 space-y-4">
                {/* Project Header */}
                <div>
                  <h3 className="text-xl font-bold text-foreground mb-2">
                    {project?.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {project?.description}
                  </p>
                </div>

                {/* Key Features */}
                <div>
                  <h4 className="font-semibold text-foreground mb-2 text-sm">Key Features:</h4>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
                    {project?.features?.map((feature, idx) => (
                      <div key={idx} className="flex items-center space-x-2 text-xs text-muted-foreground">
                        <Icon name="Check" size={12} className="text-success flex-shrink-0" />
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Technologies */}
                <div>
                  <h4 className="font-semibold text-foreground mb-2 text-sm">Technologies:</h4>
                  <div className="flex flex-wrap gap-2">
                    {project?.technologies?.map((tech, idx) => (
                      <span
                        key={idx}
                        className="bg-muted text-muted-foreground px-2 py-1 rounded text-xs font-medium"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex gap-3 pt-2">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => window.open(project?.githubUrl, '_blank')}
                    iconName="Github"
                    iconPosition="left"
                    iconSize={16}
                    className="flex-1"
                  >
                    Backend Code
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => window.open(project?.githubFeUrl, '_blank')}
                    iconName="Github"
                    iconPosition="left"
                    iconSize={16}
                    className="flex-1"
                  >
                    Frontend Code
                  </Button>
                  <Button
                    variant="default"
                    size="sm"
                    onClick={() => window.open(project?.liveUrl, '_blank')}
                    iconName="ExternalLink"
                    iconPosition="left"
                    iconSize={16}
                    className="flex-1"
                  >
                    Live Demo
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Projects Summary */}
        <div className="mt-16 text-center">
          <div className="bg-background rounded-2xl p-8 shadow-elevation-1">
            <h3 className="text-2xl font-bold text-foreground mb-4">
              Want to see more projects?
            </h3>
            <p className="text-muted-foreground mb-6 max-w-2xl mx-auto">
              These are just a few highlights from my portfolio. I have many more projects
              showcasing different technologies and problem-solving approaches.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="outline"
                onClick={() => window.open('https://github.com/tharsh95', '_blank')}
                iconName="Github"
                iconPosition="left"
                iconSize={18}
              >
                View All on GitHub
              </Button>
              <Button
                variant="default"
                onClick={() => {
                  const contactSection = document.getElementById('contact');
                  if (contactSection) {
                    contactSection?.scrollIntoView({
                      behavior: 'smooth',
                      block: 'start'
                    });
                  }
                }}
                iconName="MessageCircle"
                iconPosition="left"
                iconSize={18}
              >
                Discuss Your Project
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;